import { render } from "./DataComponent.vue?vue&type=template&id=3f33cf7e&scoped=true"
import script from "./DataComponent.vue?vue&type=script&lang=js"
export * from "./DataComponent.vue?vue&type=script&lang=js"

import "./DataComponent.vue?vue&type=style&index=0&id=3f33cf7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f33cf7e"]])

export default __exports__